import { Button } from 'shared/components/ui';
import React, { useState, useEffect } from 'react';
import { validarEntrada } from '../utils/validacionGastos';
import './FormEntrada.css';

/**
 * Calcula la fecha por defecto para el formulario.
 * Si la fecha actual está dentro del mes/año indicado, retorna hoy.
 * Si no, retorna el primer día del mes.
 */
function getFechaDefault(mesActual, anioActual) {
  const hoy = new Date();
  if (hoy.getMonth() + 1 === mesActual && hoy.getFullYear() === anioActual) {
    return hoy.toISOString().split('T')[0];
  }
  const mes = String(mesActual).padStart(2, '0');
  return `${anioActual}-${mes}-01`;
}

const FormEntrada = ({ entrada, onSubmit, onCancel, loading, mesActual, anioActual }) => {
  const esEdicion = entrada !== null && entrada !== undefined;

  const [descripcion, setDescripcion] = useState('');
  const [monto, setMonto] = useState('');
  const [fecha, setFecha] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (esEdicion) {
      setDescripcion(entrada.descripcion || '');
      setMonto(entrada.monto != null ? String(entrada.monto) : '');
      setFecha(entrada.fecha || '');
    } else {
      setDescripcion('');
      setMonto('');
      setFecha(getFechaDefault(mesActual, anioActual));
    }
    setErrors({});
  }, [entrada, mesActual, anioActual, esEdicion]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const resultado = validarEntrada({
      descripcion,
      monto,
      fecha,
      mes: mesActual,
      anio: anioActual,
    });

    if (!resultado.valid) {
      setErrors(resultado.errors);
      return;
    }

    setErrors({});
    onSubmit({ descripcion: descripcion.trim(), monto, fecha });
  };

  return (
    <form className="fe-form" onSubmit={handleSubmit} noValidate>
      {/* Descripción */}
      <div className="fe-campo">
        <label className="fe-label" htmlFor="fe-descripcion">
          Descripción
        </label>
        <input
          id="fe-descripcion"
          type="text"
          className={`fe-input ${errors.descripcion ? 'fe-input-error' : ''}`}
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
          maxLength={200}
          disabled={loading}
          aria-invalid={!!errors.descripcion}
          aria-describedby={errors.descripcion ? 'fe-error-descripcion' : undefined}
          placeholder="Descripción de la entrada"
        />
        {errors.descripcion && (
          <span id="fe-error-descripcion" className="fe-error" role="alert">
            {errors.descripcion}
          </span>
        )}
      </div>

      {/* Monto */}
      <div className="fe-campo">
        <label className="fe-label" htmlFor="fe-monto">
          Monto
        </label>
        <input
          id="fe-monto"
          type="number"
          className={`fe-input ${errors.monto ? 'fe-input-error' : ''}`}
          value={monto}
          onChange={(e) => setMonto(e.target.value)}
          min="0.01"
          max="999999999.99"
          step="0.01"
          disabled={loading}
          aria-invalid={!!errors.monto}
          aria-describedby={errors.monto ? 'fe-error-monto' : undefined}
          placeholder="0.00"
        />
        {errors.monto && (
          <span id="fe-error-monto" className="fe-error" role="alert">
            {errors.monto}
          </span>
        )}
      </div>

      {/* Fecha */}
      <div className="fe-campo">
        <label className="fe-label" htmlFor="fe-fecha">
          Fecha
        </label>
        <input
          id="fe-fecha"
          type="date"
          className={`fe-input ${errors.fecha ? 'fe-input-error' : ''}`}
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          disabled={loading}
          aria-invalid={!!errors.fecha}
          aria-describedby={errors.fecha ? 'fe-error-fecha' : undefined}
        />
        {errors.fecha && (
          <span id="fe-error-fecha" className="fe-error" role="alert">
            {errors.fecha}
          </span>
        )}
      </div>

      {/* Acciones */}
      <div className="fe-acciones">
        <Button
          type="submit"
          className="fe-btn fe-btn-primary"
          disabled={loading}
        >
          {loading && <span className="fe-spinner" aria-hidden="true" />}
          Guardar
        </Button>
        <Button
          type="button"
          className="fe-btn fe-btn-secondary"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
      </div>
    </form>
  );
};

export default FormEntrada;
